<template>
  <component :is="component">
    <span :class="letterCountClass">{{ letterCount }}</span>
    /
    <span>{{ limit }}</span>
  </component>
</template>

<script>

import Input from '../Input'
import defaultRootComponent from '../defaultRootComponent'

export default {
  name: 'LetterCount',

  mixins: [ defaultRootComponent('span') ],

  props: {
    value: String,
    limit: Number
  },

  computed: {
    letterCount () {
      return this.value.length
    },

    overTheLimit () {
      return this.letterCount >= this.limit
    },

    closeToTheLimit () {
      /* arbitrary threshold, closing in on 25% to the end of the limit */
      const threshold = this.limit - Math.floor(this.limit / 4)

      return this.letterCount > threshold
    },

    letterCountClass () {
      return {
        [ this.$style.closeToTheLimit ]: this.closeToTheLimit,
        [ this.$style.overTheLimit ]: this.overTheLimit
      }
    }
  }
}

</script>

<style module>

.closeToTheLimit {
  /* TODO: theme orange */
  color: orange;
}

.overTheLimit {
  /* TODO: theme red */
  color: red;
}

</style>
